export type JustifiedQuestionTextProps = {
  text: string;
  className?: string;
};

export function JustifiedQuestionText({ text, className = "" }: JustifiedQuestionTextProps) {
  const normalizedText = String(text || "").trim();

  if (!normalizedText) return null;

  const paragraphs = normalizedText
    .split(/\n{2,}/)
    .map((p) => p.trim())
    .filter(Boolean);

  return (
    <div className={`space-y-4 ${className}`}>
      {paragraphs.map((paragraph, index) => (
        <p
          key={index}
          className="text-justify leading-relaxed whitespace-pre-line"
          style={{ textAlign: "justify" }}
        >
          {paragraph}
        </p>
      ))}
    </div>
  );
}
